import React, { Component } from 'react'
import { actions } from 'react-redux-form/immutable'

import FormContainer from './form-container'

class AdvisingNew extends Component {

  render() {
    return (
      <FormContainer isNew />
    )
  }
}

AdvisingNew.onEnter = (store) => () => {
  store.dispatch(actions.change('advisingState.id', 0))
  store.dispatch(actions.change('advisingState.student_id', 0))
  store.dispatch(actions.change('advisingState.student_id_code', ''))
  store.dispatch(actions.change('advisingState.student_name', ''))
}

export default AdvisingNew



// WEBPACK FOOTER //
// ./src/containers/Advising/new.js